import React, { useState } from 'react';
import { Send, CheckCircle, Loader2, Mail, User, MessageSquare } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [status, setStatus] = useState('idle');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.message) return;

    setStatus('loading');
    
    setTimeout(() => {
      setStatus('success');
      const mailtoUrl = `mailto:hello@summarygpt.com?subject=Contact%20from%20${encodeURIComponent(formData.name)}&body=${encodeURIComponent(`Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`)}`;
      window.location.href = mailtoUrl;
    }, 1000);
  };

  if (status === 'success') {
    return (
      <div className="text-center py-12">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-emerald-500/10 border border-emerald-500/25 mb-6">
          <CheckCircle className="w-8 h-8 text-emerald-400" />
        </div>
        <h3 className="text-2xl font-bold text-white mb-3">Message sent!</h3>
        <p className="text-slate-400">We'll get back to you as soon as possible.</p>
      </div>
    );
  }

  return (
    <div className="w-full max-w-xl mx-auto">
      <div className="text-center mb-10">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Get in touch
        </h2>
        <p className="text-lg text-slate-400">
          Have questions or want to work together? Drop us a message.
        </p>
      </div>
      
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="relative">
          <User className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-500" />
          <Input
            type="text"
            name="name"
            placeholder="Your name"
            value={formData.name}
            onChange={handleChange}
            required
            className="h-14 pl-12 pr-5 bg-slate-900/60 border-slate-700/80 text-white placeholder:text-slate-500 focus:border-amber-500/50 focus:ring-amber-500/20 rounded-xl text-base"
          />
        </div>

        <div className="relative">
          <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-500" />
          <Input
            type="email"
            name="email"
            placeholder="Your email"
            value={formData.email}
            onChange={handleChange}
            required
            className="h-14 pl-12 pr-5 bg-slate-900/60 border-slate-700/80 text-white placeholder:text-slate-500 focus:border-amber-500/50 focus:ring-amber-500/20 rounded-xl text-base"
          />
        </div>

        <div className="relative">
          <MessageSquare className="absolute left-4 top-4 w-5 h-5 text-slate-500" />
          <Textarea
            name="message"
            placeholder="Your message"
            value={formData.message}
            onChange={handleChange}
            required
            rows={5}
            className="pl-12 pr-5 py-4 bg-slate-900/60 border-slate-700/80 text-white placeholder:text-slate-500 focus:border-amber-500/50 focus:ring-amber-500/20 rounded-xl text-base resize-none"
          />
        </div>

        <Button
          type="submit"
          disabled={status === 'loading'}
          className="w-full h-14 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-400 hover:to-orange-400 text-slate-900 font-semibold shadow-lg shadow-amber-500/25 hover:shadow-amber-500/35 transition-all duration-300 border-0 gap-2 disabled:opacity-50 rounded-xl text-lg"
        >
          {status === 'loading' ? (
            <Loader2 className="w-5 h-5 animate-spin" />
          ) : (
            <>
              Send Message
              <Send className="w-5 h-5" />
            </>
          )}
        </Button>
      </form>
    </div>
  );
};

export default ContactForm;
